/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FunctionComponent, ReactElement, useContext, useEffect, useRef } from 'react';
import {
  CreditsProjectRules,
  GenderInput,
  GenderInputDS,
  NumericInput,
  SelectedButton,
} from '../../components/DesignSystem';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { ValidityHtmlElement } from '../../utils/DsType';
import S from './styles';

const NouveauProject: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const projectRef = useRef<GenderInputDS>(null);

  const {
    state: { loans },
    dispatch,
  } = useContext(store);

  const onProjectChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (!!projectRef && projectRef.current !== null) {
      (projectRef.current as unknown as ValidityHtmlElement).assignValidity();
      dispatch(updateStore({ loans: { creditsProject: e.currentTarget?.value } }));
    }
  };

  const onProjectAmountChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ loans: { newProjectAmount: Number(String(e.currentTarget?.value).replace(/\s/g, '')) } }));
  };

  useEffect(() => {
    if (loans?.creditsProject !== 'true') {
      dispatch(updateStore({ loans: { newProjectAmount: '' } }));
    }
  }, [loans?.creditsProject]);

  const renderAmount = () => {
    if (loans?.creditsProject === 'true') {
      return (
        <>
          <NumericInput
            class="to-validate trackable-blur"
            label="Montant total du projet"
            maxLength="6"
            placeholder="Somme totale"
            suffix="€"
            value={loans?.newProjectAmount}
            onLetterChanged={onProjectAmountChange}
            onInputChange={onProjectAmountChange}
            replacement={CreditsProjectRules.replacement}
            customValidityPattern={CreditsProjectRules.customValidityPattern}
          />
        </>
      );
    } else {
      return null;
    }
  };
  return (
    <>
      <S.CreditsContainer>
        <S.ProjectContainer>
          <GenderInput
            ref={projectRef}
            class="to-validate trackable-click"
            label="Souhaitez-vous en profiter pour financer un nouveau projet ?"
            data-id="creditsProject"
            onSelectedElementChange={onProjectChange}
            value={loans?.creditsProject}
            error-message="Veuillez choisir Oui ou Non."
          >
            <SelectedButton className="btn" value={'true'} secondary>
              Oui
            </SelectedButton>
            <SelectedButton className="btn" value={'false'} secondary>
              Non
            </SelectedButton>
          </GenderInput>
          {renderAmount()}
        </S.ProjectContainer>
      </S.CreditsContainer>
    </>
  );
};

export default NouveauProject;
